import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';

@Component({
    selector: 'app-faq-table',
    templateUrl: './faq-table.component.html',
    styleUrls: ['./faq-table.component.css']
})
export class FaqTableComponent implements OnInit, OnChanges {
    @Input() list: any[] = [];
    @Output() sort = new EventEmitter<any>();
    dataSource = new MatTableDataSource<any>();
    readColumns: String[] = [
        'title',
        'moderNm',
        'regDt',
        'hitCnt'

    ];

    constructor() {
    }

    ngOnInit(): void {
        this.loadDataSource();

    }

    loadDataSource() {
        this.dataSource.data = this.list;
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
        }
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }

}
